'use strict';

var cache = {};

module.exports = {
    initTabCache: function () {
        cache.$document = $(document);
        cache.$tabLink = $('.js-tab-link');
    },
    tabEvents: function () {
        cache.$tabLink.on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $tabContent = $this.closest('.js-category-tabs').find('.js-tab-content');
            var $tabLink = $this.closest('.js-category-tabs').find('.js-tab-link');
            var tabTarget = $this.data('tab-target');
            var $selectedTab = $(tabTarget);

            $tabLink.removeClass('active-tab').attr('aria-selected', 'false');
            $this.addClass('active-tab').attr('aria-selected', 'true');
            $tabContent.removeClass('active-content');
            $selectedTab.addClass('active-content');

            cache.$document.trigger('tab:changed', {
                $selectedTab: $selectedTab
            });
        });
    }
};
